import { inject, Injectable } from '@angular/core';

import { STORAGE_CONFIG } from '../tokens/config.token';
import { StorageFactory } from '../utils/storage-factory';

/**
 * CryptoStorage позволяет не в явном виде хранить чувствительные данные, не гарантирует защиты данных от взлома.
 */
@Injectable({
  providedIn: 'root',
})
export class CryptoStorageService implements Storage {
  private _config = inject(STORAGE_CONFIG);

  private _storage = StorageFactory.createCryptoStorage(this._config.version, this._config.secretKey);

  public get length(): number {
    return this._storage.length;
  }

  public getItem(key: string, storage?: Storage): string | null {
    return this._storage.getItem(key, storage);
  }

  public setItem(key: string, value: string, storage?: Storage): void {
    this._storage.setItem(key, value, storage);
  }

  public key(index: number, storage?: Storage): string | null {
    return this._storage.key(index, storage);
  }

  public removeItem(key: string, storage?: Storage): void {
    this._storage.removeItem(key, storage);
  }

  public clear(storage?: Storage): void {
    this._storage.clear(storage);
  }
}
